import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import EditInputs from './EditInputs';
import { ChevronDoubleUp, ChevronDoubleDown } from 'react-bootstrap-icons';
import { Collapse, Button } from 'reactstrap';

function InputsAdmin({ username }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalItemID, setModalItemID] = useState(null);
    const [ showSection, setShowSection ] = useState(false);

    useEffect(() => {
        getInputs();
    }, []);

    function handleDefaultItemClick(itemID) {
        setModalItemID(itemID);
        setShowModal(true);
    };

    function getInputs() {
        fetch('/api/Inputs')
            .then((response) => {
                return response.json();
            })
            .then((actualData) => {
                setData(actualData);
                setError(null);
            })
            .catch((err) => {
                setError(err.message);
                setData(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            <EditInputs getInputs={getInputs} setModalItemID={setModalItemID} showModal={showModal} itemID={modalItemID} setShowModal={setShowModal} username={username} />
            <div className="bg-light">
                <div className="sectionHeader adminHeader">
                    <div className="sectionHeaderWrapper">
                        <span>Inputs</span>
                        <span className="sectionHeaderTag">Employee Provided</span>
                    </div>
                    <Button onClick={()=> setShowSection(!showSection) } className='btn-toggle'>
                        {!showSection && <ChevronDoubleDown className="toggleImage" />}
                        {showSection && <ChevronDoubleUp className="toggleImage" />}
                        </Button></div>
                <Collapse isOpen={showSection}>
                    <div className="list-group">
                        {loading && <div>Loading...</div>}
                        {error && (
                            <div>{`There is a problem fetching the post data - ${error}`}</div>
                        )}
                        {data &&
                            data.map(({ id, name }) => (
                                <a key={id} onClick={() => handleDefaultItemClick(id)} className="list-group-item list-group-item-action">{name}</a>
                            ))}
                    </div>
                </Collapse>
            </div>
        </>
    )
}

export default InputsAdmin;
